<template>
  <div>
    <v-centerForm>
      <template slot='left'>
        <el-form inline :model="searchForm" ref="searchForm" label-width="100px">
          <el-form-item label="账号名称" prop="accountName">
            <el-input placeholder="请输入账号名称" v-model="searchForm.accountName" clearable></el-input>
          </el-form-item>
          <el-form-item label="登录状态" prop="loginStatus">
            <el-select v-model="searchForm.loginStatus" placeholder="请选择登录状态" clearable>
              <el-option label="成功" value="success"></el-option>
              <el-option label="失败" value="failed"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="登录时间">
            <el-date-picker
              v-model="searchForm.loginTimeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
            <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template slot='right'>
        <el-button icon="el-icon-refresh" @click="refresh">刷新</el-button>
      </template>
    </v-centerForm>

    <v-tableEncapsulation
      :loading="loadingBtn.tableLoading"
      :columnData="columnData"
      :tableSize="pagination.size"
      :tableData="tableData"
      :tableTotal="pagination.total"
      :currentPage="pagination.current"
      @currentPage="handleCurrentChange"
      @sizeChange="handleSizeChange">
      <el-table-column slot="loginStatus" label="登录状态" align="center" width="100px">
        <template slot-scope="scope">
          <el-tag :type="scope.row.loginStatus === 'success' ? 'success' : 'danger'" effect="dark">
            {{ scope.row.loginStatusText }}
          </el-tag>
        </template>
      </el-table-column>
    </v-tableEncapsulation>
  </div>
</template>

<script>
import { queryRiskLoginLogList } from '@/api/risk/riskApi'

export default {
  name: 'riskLoginLog',

  data () {
    return {
      searchForm: {
        accountName: null,
        loginStatus: null,
        loginTimeRange: null
      },
      loadingBtn: {
        tableLoading: false
      },
      columnData: [
        {
          type: 'index',
          label: '序号',
          width: '60px'
        },
        {
          label: '账号ID',
          prop: 'accountId',
          width: '100px'
        },
        {
          label: '账号名称',
          prop: 'accountName',
          width: '150px'
        },
        {
          label: '登录时间',
          prop: 'loginTime',
          width: '160px'
        },
        {
          label: '登录IP',
          prop: 'loginIp',
          width: '130px'
        },
        {
          label: '登录设备',
          prop: 'loginDevice',
          width: '120px'
        },
        {
          label: '登录浏览器',
          prop: 'loginBrowser',
          width: '120px'
        },
        {
          slot: 'loginStatus'
        },
        {
          label: '失败原因',
          prop: 'failReason',
          width: '150px'
        },
        {
          label: '登录地点',
          prop: 'location',
          width: '100px'
        }
      ],
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },

  methods: {
    // 搜索
    search () {
      this.pagination.current = 1
      this.getTableData()
    },

    // 重置搜索
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.searchForm.loginTimeRange = null
      this.pagination.current = 1
      this.getTableData()
    },

    // 刷新
    refresh () {
      this.getTableData()
    },

    // 获取表格数据
    getTableData () {
      this.loadingBtn.tableLoading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.size,
        ...this.searchForm
      }

      // 处理日期范围
      if (params.loginTimeRange && params.loginTimeRange.length === 2) {
        params.loginTimeStart = params.loginTimeRange[0]
        params.loginTimeEnd = params.loginTimeRange[1]
      }
      delete params.loginTimeRange

      // 移除空值
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === '' || params[key] === undefined) {
          delete params[key]
        }
      })

      queryRiskLoginLogList(params).then(({ data, code }) => {
        if (code === this.$constant.SUCCESS) {
          this.tableData = data.records || []
          this.pagination.total = data.total || 0
        }
        this.loadingBtn.tableLoading = false
      }).catch(() => {
        this.loadingBtn.tableLoading = false
      })
    },

    // 页码变化
    handleCurrentChange (current) {
      this.pagination.current = current
      this.getTableData()
    },

    // 每页条数变化
    handleSizeChange (size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.getTableData()
    }
  },

  created () {
    this.getTableData()
  }
}
</script>

<style lang="scss" scoped>
</style>
